var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0045 13.7227C25.6937 13.7227 20.576 18.8404 20.576 25.1512C20.576 31.4621 25.6937 36.5798 32.0045 36.5798C38.3154 36.5798 43.4331 31.4621 43.4331 25.1512C43.4331 18.8404 38.3154 13.7227 32.0045 13.7227Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2674 52.4023C50.1737 46.1806 45.0994 41.1429 38.8571 41.1429H25.1429C18.8983 41.1429 13.824 46.1806 13.7303 52.4023C8.12343 47.376 4.57143 40.1051 4.57143 32C4.57143 16.8777 16.8754 4.57143 32 4.57143C47.1223 4.57143 59.4286 16.8777 59.4286 32C59.4286 40.1051 55.8743 47.376 50.2674 52.4023ZM32 0C14.3543 0 0 14.3543 0 32C0 49.6457 14.3543 64 32 64C49.6434 64 64 49.6457 64 32C64 14.3543 49.6434 0 32 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircle);
export default __webpack_public_path__ + "static/media/person-circle.5bec17926b6407edaaf022d66fd92d97.svg";
export { ForwardRef as ReactComponent };